module.exports = __webpack_public_path__ + "media/react/assets/images/google-6a4a3529e1113ea7b8eaea9cac92c436.svg";